import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { authFetchBaseQuery, baseManagementUrl } from '../managementApiConfig';

export interface HomeConsentRequest {
  unitId: string;
}

export interface HomeConsent {
  consented: boolean;
  userId?: string;
  updatedAt: string;
}

export interface SetHomeConsentRequest {
  unitId: string;
  consented: boolean;
}

export const unitsManagementApi = createApi({
  reducerPath: 'unitsManagementApi',
  baseQuery: authFetchBaseQuery({
    baseUrl: `${baseManagementUrl}/units`,
  }),
  endpoints: (builder) => ({
    getConsent: builder.query<HomeConsent, HomeConsentRequest>({
      query: ({ unitId }) => ({ url: `${unitId}/consent` }),
    }),
    saveConsent: builder.mutation<HomeConsent, SetHomeConsentRequest>({
      query: ({ unitId, consented }) => ({
        url: `${unitId}/consent`,
        method: 'PUT',
        body: { consented },
      }),
      onQueryStarted: async (request, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(
          unitsManagementApi.util.upsertQueryData('getConsent', { unitId: request.unitId }, data),
        );
      },
    }),
  }),
});

export const { useGetConsentQuery, useLazyGetConsentQuery, useSaveConsentMutation } =
  unitsManagementApi;
